var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-root"},[_vm._m(0),_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"item"},[_c('span',[_vm._v(_vm._s(item.name))]),_c('MyImage',{attrs:{"info":item},on:{"open":_vm.openWorld}})],1)}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h1',[_vm._v("新疆")]),_c('h4',[_vm._v("这里是新疆之旅所有全景照片")])])
}]

export { render, staticRenderFns }